'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = require('react-redux');

var _InfiniteScroll = require('../shared/InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _propTypes = require('../../shared/prop-types');

var _ConfirmDismissFeedItem = require('../../components/ConfirmDismissFeedItem');

var _ConfirmDismissFeedItem2 = _interopRequireDefault(_ConfirmDismissFeedItem);

var _FeedItem = require('../../components/FeedItem');

var _FeedItem2 = _interopRequireDefault(_FeedItem);

var _MiniProfile = require('../MiniProfile');

var _MiniProfile2 = _interopRequireDefault(_MiniProfile);

var _presetFilterType = require('../../shared/preset-filter-type');

var _presetFilterType2 = _interopRequireDefault(_presetFilterType);

var _loggingUtil = require('../../utils/logging-util');

var _pagescrollHelper = require('../../utils/pagescroll-helper');

var _actionCreators = require('../../store/actions/action-creators');

var _Uniform = require('../Uniform');

var _logValues = require('../../shared/logging/log-values');

var _communityContentContainers = require('../../shared/logging/community-content-containers');

var _communityContentContainers2 = _interopRequireDefault(_communityContentContainers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// import InfiniteScroll from 'react-infinite-scroller';


var defaultLogData = _defineProperty({
  app: _logValues.WEB_APP,
  container: _communityContentContainers2.default.Profile
}, _logValues.ORIGIN_KEY, _logValues.USER_TIMELINE_ORIGIN);

var ConnectedUserTimeline = function (_PureComponent) {
  _inherits(ConnectedUserTimeline, _PureComponent);

  function ConnectedUserTimeline(props) {
    _classCallCheck(this, ConnectedUserTimeline);

    var _this = _possibleConstructorReturn(this, (ConnectedUserTimeline.__proto__ || Object.getPrototypeOf(ConnectedUserTimeline)).call(this, props));

    _this.dismissFeedItem = function (feedContentId) {
      var _this$props = _this.props,
          canDismissFeedItems = _this$props.canDismissFeedItems,
          feedUserId = _this$props.feedUserId,
          isHomeTimeline = _this$props.isHomeTimeline,
          itemToDismiss = _this$props.itemToDismiss;

      if (!canDismissFeedItems) return;

      if (isHomeTimeline || !!itemToDismiss) {
        _this.props.dismissFeedItem(feedUserId.type, feedUserId.relatedId, feedContentId, isHomeTimeline);
      } else {
        // Confirm with the user before deleting
        _this.props.showConfirmDismissFeedItem(feedUserId.type, feedUserId.relatedId, feedContentId);
      }
    };

    _this.onCloseConfirmDismissFeedItem = function () {
      (0, _pagescrollHelper.enablePageScroll)();
      var feedUserId = _this.props.feedUserId;

      _this.props.hideConfirmDismissFeedItem(feedUserId.type, feedUserId.relatedId);
    };

    _this.onCloseMiniProfile = function () {
      (0, _pagescrollHelper.enablePageScroll)();
      _this.props.hideMiniProfile();
    };

    _this.state = {
      logData: _this.createLogData({}, props)
    };
    return _this;
  }

  _createClass(ConnectedUserTimeline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          feedItems = _props.feedItems,
          feedUserId = _props.feedUserId,
          isHomeTimeline = _props.isHomeTimeline,
          filterType = _props.filterType,
          forcePublicView = _props.forcePublicView;

      if (!feedItems || !feedItems.length) {
        this.props.fetchUserTimelineIfNeeded(feedUserId.type, feedUserId.relatedId, isHomeTimeline, filterType, forcePublicView);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        logData: this.createLogData(this.state.logData, nextProps)
      });
    }
  }, {
    key: 'createLogData',
    value: function createLogData(currentLogData, newProps) {
      return (0, _loggingUtil.copyLogData)(currentLogData, newProps.logData, defaultLogData);
    }
  }, {
    key: 'renderModals',
    value: function renderModals() {
      var miniProfile = _react2.default.createElement(
        _reactModal2.default,
        {
          key: 'mini-profile-modal',
          className: 'feed-modal mini-profile',
          overlayClassName: 'feed-modal-overlay',
          isOpen: !!this.props.miniProfileUserId,
          onAfterOpen: _pagescrollHelper.disablePageScroll,
          onRequestClose: this.onCloseMiniProfile,
          contentLabel: 'Profile'
        },
        _react2.default.createElement(_MiniProfile2.default, {
          feedUserId: this.props.miniProfileUserId,
          logData: this.state.logData,
          onDialogClose: this.onCloseMiniProfile,
          store: this.context.store
        })
      );

      var confirmDismissFeedItemModal = _react2.default.createElement(
        _reactModal2.default,
        {
          key: 'confirm-dismiss-feed-item-modal',
          className: 'feed-modal',
          overlayClassName: 'feed-modal-overlay',
          isOpen: !!this.props.itemToDismiss && !this.props.isHomeTimeline,
          onAfterOpen: _pagescrollHelper.disablePageScroll,
          onRequestClose: this.onCloseConfirmDismissFeedItem,
          contentLabel: 'Remove this timeline post?'
        },
        _react2.default.createElement(_ConfirmDismissFeedItem2.default, {
          dismissFeedItem: this.dismissFeedItem,
          feedItem: this.props.itemToDismiss,
          onClose: this.onCloseConfirmDismissFeedItem
        })
      );

      return _react2.default.createElement(
        'span',
        null,
        miniProfile,
        confirmDismissFeedItemModal
      );
    }
  }, {
    key: 'requestMoreFeedItems',
    value: function requestMoreFeedItems() {
      var _props2 = this.props,
          feedUserId = _props2.feedUserId,
          isHomeTimeline = _props2.isHomeTimeline,
          filterType = _props2.filterType,
          forcePublicView = _props2.forcePublicView;

      this.props.fetchMoreInTimeline(feedUserId.type, feedUserId.relatedId, isHomeTimeline, filterType, forcePublicView);
    }
  }, {
    key: 'renderLoadingSpinner',
    value: function renderLoadingSpinner() {
      if (this.props.isEndOfTimeline) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'infinite-css-spinner-wrapper' },
        _react2.default.createElement(_Uniform.Spinner, { size: 'medium' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var feedItemsArray = this.props.feedItems || [];
      var feedItems = feedItemsArray.map(function (f) {
        return _react2.default.createElement(_FeedItem2.default, { key: f,
          canDismiss: _this2.props.canDismissFeedItems,
          feedContentId: f,
          miniProfileEnabled: _this2.props.miniProfileEnabled,
          onDismissFeedItem: function onDismissFeedItem() {
            _this2.dismissFeedItem(f);
          },
          store: _this2.context.store,
          timelineUserId: _this2.props.feedUserId,
          logData: _this2.state.logData,
          waypointScrollableAncestor: _this2.props.waypointScrollableAncestor,
          adTag: _this2.props.adTag
        });
      });

      if (this.props.isEndOfTimeline && this.props.endOfTimeline) {
        // Show end of timeline component if one was provided
        feedItems.push(this.props.endOfTimeline);
      }

      return _react2.default.createElement(
        'div',
        { className: 'feed-items' },
        _react2.default.createElement(
          _InfiniteScroll2.default,
          {
            pageStart: 0,
            initialLoad: false,
            loader: this.renderLoadingSpinner(),
            loadMore: function loadMore() {
              _this2.requestMoreFeedItems();
            },
            threshold: 400,
            hasMore: !this.props.isSingleFeedPost,
            scrollNode: this.props.waypointScrollableAncestor
          },
          feedItems
        ),
        this.renderModals()
      );
    }
  }]);

  return ConnectedUserTimeline;
}(_react.PureComponent);

ConnectedUserTimeline.propTypes = {
  canDismissFeedItems: _react.PropTypes.bool,
  forcePublicView: _react.PropTypes.bool,
  dismissFeedItem: _react.PropTypes.func,
  endOfTimeline: _react.PropTypes.element,
  isEndOfTimeline: _react.PropTypes.bool,
  feedItems: _react.PropTypes.arrayOf(_react.PropTypes.string),
  feedUserId: _propTypes.FeedUserId.isRequired,
  fetchMoreInTimeline: _react.PropTypes.func.isRequired,
  fetchUserTimelineIfNeeded: _react.PropTypes.func.isRequired,
  filterType: _react.PropTypes.oneOf(Object.keys(_presetFilterType2.default).map(function (key) {
    return _presetFilterType2.default[key];
  })),
  hideMiniProfile: _react.PropTypes.func.isRequired,
  isHomeTimeline: _react.PropTypes.bool,
  itemToDismiss: _react.PropTypes.object,
  logData: _react.PropTypes.object,
  miniProfileEnabled: _react.PropTypes.bool,
  miniProfileUserId: _propTypes.FeedUserId,
  hideConfirmDismissFeedItem: _react.PropTypes.func.isRequired,
  showConfirmDismissFeedItem: _react.PropTypes.func.isRequired,
  waypointScrollableAncestor: _react.PropTypes.any,
  isSingleFeedPost: _react.PropTypes.bool,
  adTag: _propTypes.adTagShape
};
ConnectedUserTimeline.contextTypes = {
  store: _propTypes.StoreShape
};


function mapStateToProps(state, ownProps) {
  var feedUserKey = ownProps.feedUserId.type + '-' + ownProps.feedUserId.relatedId;
  var userTimeline = state && state.userTimeline && state.userTimeline[feedUserKey] || {};
  var itemToDismiss = userTimeline.dismissFeedItem,
      _userTimeline$isEndOf = userTimeline.isEndOfTimeline,
      isEndOfTimeline = _userTimeline$isEndOf === undefined ? false : _userTimeline$isEndOf,
      _userTimeline$feedIte = userTimeline.feedItems,
      feedItems = _userTimeline$feedIte === undefined ? [] : _userTimeline$feedIte;


  var miniProfileUserId = void 0;
  if (state && state.miniProfile && state.miniProfile.showingUser) {
    miniProfileUserId = state.miniProfile.showingUser.feedUserId;
  }

  return {
    isEndOfTimeline: isEndOfTimeline,
    itemToDismiss: itemToDismiss,
    feedItems: feedItems,
    miniProfileUserId: miniProfileUserId
  };
}

var mapDispatchToProps = {
  dismissFeedItem: _actionCreators.dismissFeedItem,
  fetchMoreInTimeline: _actionCreators.fetchMoreInTimeline,
  fetchUserTimelineIfNeeded: _actionCreators.fetchUserTimelineIfNeeded,
  hideMiniProfile: _actionCreators.hideMiniProfile,
  hideConfirmDismissFeedItem: _actionCreators.hideConfirmDismissFeedItem,
  showConfirmDismissFeedItem: _actionCreators.showConfirmDismissFeedItem
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConnectedUserTimeline);